module.exports = __webpack_public_path__ + "img/play.f27b678.svg";